import axios from 'src/utils/axiosCommonServices';
import CACHE_TIME from 'src/constants/cacheTime';

// Module-level Tier-2 cache. Cleared from useAccount.signOut so reference
// data does not leak to the next user on the same tab.
const _commonServicesCache = new Map();

function _get(key) {
  const e = _commonServicesCache.get(key);
  // Expiry-only check — a falsy value (null, [], 0) is still a valid cached
  // hit when within TTL.
  if (!e || Date.now() > e.expiresAt) {
    if (e) _commonServicesCache.delete(key);
    return undefined;
  }
  return e.value;
}

function _set(key, value, ttl) {
  _commonServicesCache.set(key, { value, expiresAt: Date.now() + ttl });
}

class CommonServices {
  getAllRoles = async () => {
    const KEY = 'commonServices:roles';
    const cached = _get(KEY);
    if (cached !== undefined) return cached;
    const { data } = await axios.get('/roles');
    const roles = data.roles;
    _set(KEY, roles, CACHE_TIME.THIRTY_MIN);
    return roles;
  };

  getClaimsUsersByRoleId = async (roleId, companyCode) => {
    let filter = 'pagination={"limit":25,"filters":{"role":"","companyCode":"nsd"},"page":1,"sort":"id|desc","skiptoken":null}';

    return axios.get(`/users?${filter}`);
  };

  getUsers = async (companyCode) => {
    return axios.get('/users', {
      params: {
        companyCode
      }
    });
  };
}

const commonServices = new CommonServices();

export function clearCommonServicesCache() {
  _commonServicesCache.clear();
}

export default commonServices;
